<div class="denied-wrapper" [class.dark]="themeService.isDark()">
  <div class="denied-card">
    <mat-icon class="denied-icon">lock</mat-icon>

    <h2 class="denied-title">Acceso Restringido</h2>

    <p class="denied-text">
      No tienes permisos para ver esta sección. Si crees que es un error,contacta al administrador.
    </p>

    <button mat-flat-button color="primary" class="back-button" (click)="volverAlDashboard()">
      <mat-icon>arrow_back</mat-icon>
      Volver al Dashboard
    </button>
  </div>
</div>